import SectionHeading from "./SectionHeading";
import { newsList } from "@/mocks/doujinData";

export default function Updates() {
  return (
    <section id="updates" className="py-16 md:py-24 bg-background-100">
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-start">
          <div>
            <SectionHeading
              eyebrow="更新资讯"
              title="新作动态，一手掌握"
              desc="热门画集与图包持续放送，高清原图每周批量上线，第一时间了解最新同人作品动态。"
              align="left"
            />

            <ul className="space-y-4">
              {newsList.map((item) => (
                <li
                  key={item.id}
                  className="flex items-start gap-4 rounded-xl bg-background-50 border border-background-200 p-4 md:p-5"
                >
                  <span className="inline-flex items-center px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold whitespace-nowrap">
                    {item.tag}
                  </span>
                  <div>
                    <p className="text-sm md:text-base text-foreground-950 leading-relaxed">
                      {item.title}
                    </p>
                    <p className="mt-1.5 text-xs text-foreground-500">{item.date}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:sticky lg:top-24">
            <div className="rounded-2xl overflow-hidden border border-background-200 bg-background-50">
              <img
                src="https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20sunny%20art%20studio%20desk%20with%20new%20artbooks%20stacked%20and%20a%20laptop%20showing%20colorful%20digital%20paintings%2C%20warm%20creative%20workspace%2C%20golden%20natural%20light%2C%20cozy%20and%20inspiring%2C%20doujin%20art%20style%2C%20high%20detail&width=1200&height=700&seq=doujin-update-01&orientation=landscape"
                alt="同人本子官网最新画集图包更新"
                className="w-full aspect-[16/10] object-cover"
              />
            </div>
            <div className="mt-6 rounded-2xl bg-primary-500 text-background-50 p-7 md:p-8">
              <h3 className="font-heading text-xl md:text-2xl">本周特别企划</h3>
              <p className="mt-3 text-sm md:text-base text-background-50/90 leading-relaxed">
                夏日祭典主题画集专题上线，热门作品高清原图持续放送，欢迎在线浏览收藏心仪之作。
              </p>
              <a
                href="#gallery"
                className="inline-flex items-center gap-2 mt-5 px-5 py-2.5 rounded-md bg-background-50 text-primary-700 text-sm font-semibold hover:bg-background-100 transition-colors whitespace-nowrap"
              >
                前往在线浏览
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}